import { useEffect } from 'react'
import { externalUrls } from 'consts'
import { axiosGet } from 'shared/api/axios'
import AisReportProps from '../types/AisReportProps'
import axios from 'axios';

interface usePopulateAisProps {
  reportQueryString: string
  ischildFilterErrorMessageNull: boolean
  setAis: Function
  aisReport?: AisReportProps
  setIsAisLoading: Function
}

const usePopulateAis = async (props: usePopulateAisProps) => {
  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    
    if (props.aisReport === null || props.reportQueryString.length === 0 || !props.ischildFilterErrorMessageNull){
      return;
    } 

    const cleanQueryString = (queryString : string) => {
        const params = new URLSearchParams(queryString)
        params.delete('token')
        return '?' + params.toString()
    }


    const fetchHtml = async () => {
      try{
        props.setIsAisLoading(true)
        const response = await axiosGet(externalUrls.aisUrl + '/' + props.aisReport?.id + '/' + externalUrls.aisDisplayAction + cleanQueryString(props.reportQueryString), {}, () => {},{
            headers: {
                'Accept': 'text/html',
                'X-AIS-TOKEN': props.aisReport?.aisSecurityString ?? '',
            },
            responseType: 'text',
            signal,
        })
        const htmlText = await response?.data ?? ''
        props.setAis(htmlText)
      } catch(error: any) {
        if (!axios.isCancel(error) && !(error.name === 'CanceledError')) {
          console.error(error);
        }
      } finally{
        props.setIsAisLoading(false)
      }
    }

    fetchHtml()

    return () => {
      controller.abort();
    }
        
  }, [props.reportQueryString, props.aisReport, props.ischildFilterErrorMessageNull])
}

export default usePopulateAis
